import { render, staticRenderFns } from "./ColumnManager.vue?vue&type=template&id=7d53cc25&"
import script from "./ColumnManager.vue?vue&type=script&lang=js&"
export * from "./ColumnManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports